import {
  CompanyExportRenderer_Read,
  SettlementExportRendererKey,
  SettlementExportSide,
} from '@treadinc/horizon-api-spec';

export class CompanyExportRenderer {
  constructor(
    private _id: string,
    private _renderer_key: SettlementExportRendererKey,
    private _side: SettlementExportSide,
    private _version: string,
  ) {}

  public static parse(proto: CompanyExportRenderer_Read) {
    return new CompanyExportRenderer(
      proto.id,
      proto.renderer_key,
      proto.side,
      proto.version,
    );
  }

  public get id() {
    return this._id;
  }

  public get rendererKey() {
    return this._renderer_key;
  }

  public get side() {
    return this._side;
  }

  public get version() {
    return this._version;
  }
}
